import { readOptionalEnv } from "../util/readEnv.js";


export function isDebugEnabled(): boolean {
    // Server-side.
    if (typeof window === "undefined") {
        const env = readOptionalEnv("DEPLOYMENT_ENV");
        return env === "development" || env === "staging";
    }

    // Client-side.
    return window.location.hostname !== "royalur.net";
}


export function logDebug(...args: unknown[]) {
    if (isDebugEnabled()) {
        console.log(...args);
    }
}
